import {h, Fragment} from "preact"
export default function Select({ value, onChange, className, options, label }) {
    return (
        <select
            className={`ns-selection-dropdown-menu ns-text-align-left ${className}`}
            value={value}
            onChange={onChange}
            aria-label={label || "Select"}
        >
            {options.map(option => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
    )
}